// extracted by mini-css-extract-plugin
export default {"adminBox":"frL-TzNyBw7B0oozX-ESow==","header":"_861k9-+yAhd3fVzXSZhjGQ==","content":"SJyJ25EgWKlFjJAHOml5sA==","variantDark":"B50zYoZEiWBqTlcCWOu24Q=="};